export default "__VITE_ASSET__DjEIu_eT__"